import { useEffect, useState } from "react";
import styles from "./Level.module.css";
import { localizations, getLanguage } from "./localization";
import image from "../img/Icon_Cup.png";

export const Level = (props) => {
  const [level, setLevel] = useState(props.level);

  useEffect(() => {
    setLevel(props.level);
  }, [props.level]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <img src={image} />
        <span className="title">{localizations.level[getLanguage()]}</span>
      </div>
      <p className="gameText">{level}</p>
    </div>
  );
};

export default Level;
